import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { alertIcon } from "./svg";

const ConfirmReviewModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-xl shadow-lg  w-[360px] relative text-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 focus:outline-none"
        >
          <FontAwesomeIcon icon={faXmark} className="text-gray-600 text-lg" />
        </button>

        <div className="flex justify-center my-4">
          <div className="bg-[#FFEDD5] p-3 rounded-full">
            {alertIcon}
          </div>
        </div>

        <p className="text-[22px] font-bold text-[#111827] leading-snug px-4 pb-2">
          Are you sure you want to send a review for this patient?
        </p>

        <div className="flex justify-center gap-4 p-3 bg-[#F9FAFB] rounded-b-xl">
          <button
            onClick={onClose}
            className="flex-1 py-2 border border-[#374151] shadow-md rounded-md bg-white text-gray-700 font-medium hover:!bg-[#F97316] hover:text-white transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2 border border-[#374151] shadow-md rounded-md bg-white text-gray-700 font-medium hover:!bg-[#F97316] hover:text-white transition"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmReviewModal;
